<template>
  <section>
    <ul class="filters-list">
      <li
        :class="{
          'router-link-active-parent': $route.name == 'QCChatResults',
        }"
      >
        <router-link
          :to="{
            name: 'QCChatResults',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ToStartQCChartResults',
            query: this.$route.query,
          }"
        >
          TO-START
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'CompleteQCChartResults',
            query: this.$route.query,
          }"
        >
          COMPLETED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
